import { useEffect } from 'react';

const stats = [
  { number: '20+', suffix: '', label: 'Años de experiencia operativa en transporte empresarial' },
  { number: '2', suffix: '', label: 'Ciudades de cobertura directa: San Luis Potosí y Monterrey' },
  { number: '100', suffix: '%', label: 'Compromiso de puntualidad en cada trayecto' },
];

export default function AboutSection() {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.15 }
    );

    const elements = document.querySelectorAll('.about-animate');
    elements.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section className="py-20 md:py-32 bg-yakis-white relative overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-yakis-gold/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" />
      <div className="absolute bottom-0 left-0 w-72 h-72 bg-yakis-gold/5 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2" />

      <div className="section-container relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Left - Content */}
          <div>
            <div className="about-animate animate-on-scroll mb-4">
              <span className="text-yakis-gold text-sm font-semibold tracking-wider uppercase">
                Sobre Nosotros
              </span>
            </div>

            <h2 className="about-animate animate-on-scroll font-display font-bold text-3xl sm:text-4xl md:text-5xl text-yakis-navy leading-tight mb-6">
              Transformamos la
              <br />
              <span className="text-yakis-gold">movilidad empresarial</span>
              <br />
              en experiencia premium
            </h2>

            <p className="about-animate animate-on-scroll text-yakis-silver text-base md:text-lg leading-relaxed mb-8">
              Desde hace más de dos décadas, Yakis se ha posicionado como el aliado estratégico 
              de empresas manufactureras y corporativas en México. Nuestra misión es simple pero 
              poderosa: llevar a cada colaborador a su destino con seguridad, puntualidad y el 
              confort que merece.
            </p>

            <p className="about-animate animate-on-scroll text-yakis-silver text-base leading-relaxed mb-10">
              Con flota renovada, tecnología de rastreo en tiempo real y conductores altamente 
              capacitados, ofrecemos una solución de transporte que va más allá del simple traslado: 
              brindamos tranquilidad a los directivos y comodidad al personal.
            </p>

            {/* Stats */}
            <div className="about-animate animate-on-scroll grid grid-cols-1 sm:grid-cols-3 gap-6">
              {stats.map((stat, i) => (
                <div key={i} className="border-l-2 border-yakis-gold pl-5">
                  <p className="font-display font-bold text-3xl md:text-4xl text-yakis-gold">
                    {stat.number}
                    <span className="text-yakis-gold">{stat.suffix}</span>
                  </p>
                  <p className="text-sm text-yakis-silver mt-2 leading-snug">
                    {stat.label}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* Right - Image */}
          <div className="about-animate animate-on-scroll relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://static.readdy.ai/image/45c2ae79549b129e69766d02f53aa268/b142ca77d55b57e0b2180b739d97861f.png"
                alt="Interior premium de autobús ejecutivo Yakis"
                className="w-full h-[500px] md:h-[600px] object-cover object-top"
              />

            </div>

            {/* Floating decorative element */}
            <div className="absolute -top-6 -right-6 w-24 h-24 bg-yakis-gold/20 rounded-2xl -z-10 hidden lg:block" />
            <div className="absolute -bottom-6 -left-6 w-32 h-32 border-2 border-yakis-gold/20 rounded-2xl -z-10 hidden lg:block" />
          </div>
        </div>
      </div>
    </section>
  );
}